// Needed for async/await
import "regenerator-runtime/runtime";
import React, { useEffect, useState } from "react";
import { query } from "../utils/utils";
import SubNavigation from "./sub_navigation";
import { fetchNavigationData } from "../utils/api";
import {
  udpateTabSticking,
  getBaseUrl,
  checkStickyImage,
} from "../utils/utils";

const MenuDesktop = () => {
  /**
   * EXTERNAL TOGGLES
   */

  const pageHeader = query("#page-header");
  const layerInner = query(".desktop-layer-inner", pageHeader);
  const layerOuter = query(".desktop-layer-outer", pageHeader);
  const layerUpper = query(".layer-upper", layerInner);

  let baseUrl = getBaseUrl();

  // States
  //const [navigationItems, setNavigationItems] = useState([]);
  //const [currentNavigation, setCurrentNavigation] = useState(null);

  const [rootNavigationItems, setRootNavigationItems] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [stickyLogo, setStickyLogo] = useState(false);

  //SubNavigation
  const [openSubNavigation, setOpenSubNavigation] = useState(false);
  const [subNavigationItems, setSubNavigationItems] = useState(null);
  const [subNavigationRoot, setSubNavigationRoot] = useState([]);

  //SubNavigation2
  const [sub2NavigationItems, setSub2NavigationItems] = useState(null);

  //SubNavigation3
  const [sub3NavigationItems, setSub3NavigationItems] = useState(null);

  /**
   * Get the new navigation data for a given url.
   *
   * @param {string} url The (base) url to get the navigation information for.
   * @param rootnavigation
   * @param subnavigaton
   * @param sub2navigation
   * @param sub3navigation
   * @memberof SlwfNavigation
   */
  async function getNavigationData(
    url,
    rootnavigation = true,
    subnavigation = false,
    sub2navigation = false,
    sub3navigation = false,
  ) {
    /**
         * Check if the given url has already been processed and is stored in the
         * local state for navigation items.
         * Todo: Add back and make work if everything is done
         const existingNavigation = navigationItems.find((el) => {
      return el["@id"] === navigationId;
    });

         */
    /**
     * If the url has already been processed we set the current navigation item
     * to the existing information.
     *
     * We can assume that the component is used within one request cycle in
     * the frontend. After using this component a new page will be loaded
     * and we get fresh urls.
     */

    /**
     * Indicate that the loading starts.
     */
    setIsLoading(true);

    // Todo Add test if already exits in state and use
    fetchNavigationData(url)
      .then((response) => response.json())
      .then((data) => {
        // Check if we are the root and save it extra
        if (baseUrl === url) {
          setRootNavigationItems(data);
        }
        if (subnavigation) {
          setSubNavigationItems(data);
        }
        if (sub2navigation) {
          setSub2NavigationItems(data);
        }
        if (sub3navigation) {
          setSub3NavigationItems(data);
        }
        setIsLoading(false);
      });
  }

  /**
   * reset openSubNavigation when clicking away from open panel
   */

  document.addEventListener("click", (event) => {
    if (
      event.target.closest(".menu-toggle") == null &&
      event.target.closest(".panels-inner") == null
    ) {
      setOpenSubNavigation(false);
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      setOpenSubNavigation(false);
    }
  });

  function updateLayerHeight(e) {
    // console.log('updating layer height')
    if (!openSubNavigation) {
      layerOuter.style.height = "auto";
    } else {
      const { height } = layerInner.getBoundingClientRect();
      layerOuter.style.height = `${height}px`;
    }
    udpateTabSticking();
  }

  // Fill the state on mount
  useEffect(() => {
    /**
     * Fetch the navigation data.
     */
    if (baseUrl) {
      getNavigationData(baseUrl);
      getStickyLogo(baseUrl);
    }
  }, []);

  // Toggles panel states on open/close of SubNav
  useEffect(() => {
    const lastScrollPosn = window.pageYOffset;
    if (!openSubNavigation) {
      //console.log("SubNav closed")
      const headerScroll = Math.min(
        lastScrollPosn,
        layerUpper.getBoundingClientRect().height,
      );
      layerInner.classList.remove("fix");
      document.body.classList.remove("has-modal");
      updateLayerHeight();
      layerInner.scrollTop = headerScroll;
      window.removeEventListener("scroll", udpateTabSticking);
      layerInner.addEventListener("scroll", udpateTabSticking, {
        passive: true,
      });
    } else {
      //console.log("SubNav open")
      const headerScroll = layerInner.scrollTop;
      updateLayerHeight();
      window.scroll(0, Math.max(headerScroll, lastScrollPosn));
      layerInner.scrollTop = 0;
      layerInner.removeEventListener("scroll", udpateTabSticking);
      window.addEventListener("scroll", udpateTabSticking, { passive: true });
    }
  }, [openSubNavigation]);

  const getStickyLogo = async (baseUrl) => {
    /**
     * Return the Sticky Logo url if exits. If not fallback to normal logo
     */
    let jsonData = await checkStickyImage(baseUrl);
    if (jsonData) {
      setStickyLogo(baseUrl + "/@@images/sticky_logo");
    } else {
      setStickyLogo(baseUrl + "/@@images/logo");
    }
  };

  /**
   * Render the navigation items.
   *
   * @return {*} JSX code.
   * @memberof SlwfNavigation
   *
   *
   */
  function _renderRootNavigationItems() {
    let itemStructure = (
      <div className="tabs-list chain-s ai-center jc-center rel">
        <a
          href={baseUrl}
          className="home-link abs d-flex ai-center"
          style={{ width: "100px" }}
        >
          <img
            sizes="100px"
            src={stickyLogo ? stickyLogo : undefined}
            alt="Logo"
          />
        </a>
        {rootNavigationItems?.items.map((item) => {
          let klass = "menu-toggle sans-m1 link-outer";
          if (item["@id"] === baseUrl) {
            klass += "inpath";
          }

          let clickHandler;
          // If no subnavi - act as link
          clickHandler = (e) => {
            e.preventDefault();
            location.href = item["@id"];
          };
          if (item?.has_children) {
            klass += " has_children";
            clickHandler = (e) => {
              e.preventDefault();
              getNavigationData(item["@id"], false, true, false, false);
              setOpenSubNavigation(true);
              setSubNavigationRoot(item);
            };
          }
          return (
            <a
              className={klass}
              key={item["@id"].toString()}
              onClick={clickHandler}
              href={item["@id"]}
            >
              {item.title}
            </a>
          );
        })}
      </div>
    );

    return itemStructure;
  }

  return (
    <>
      <div className="tabs-outer rel">
        <div className="tabs-inner w-100">
          <div className="wrap-last clip">
            <div className="tabs-frame frame bg-lite">
              {_renderRootNavigationItems()}
            </div>
          </div>
        </div>
      </div>
      {openSubNavigation ? (
        <SubNavigation
          isLoading={isLoading}
          getNavigationData={getNavigationData}
          setOpenSubNavigation={setOpenSubNavigation}
          subNavigationItems={subNavigationItems}
          subNavigationRoot={subNavigationRoot}
          sub2NavigationItems={sub2NavigationItems}
          sub3NavigationItems={sub3NavigationItems}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default MenuDesktop;
